export const constantes = {
    dmi_key: "5MNOcGYHDc7Zoxjyk9NjPaM5BXbQK5EP",
    dmi_endpoint: "https://impact.dowino.com/service/",
    dmi_bonusPoints: 1200,
    dmi_formNum: 1,
    versionUIDsAllowedForms: ["dowino", "Webhelp", "forum-refugies", "sncf"],
}